import { createSelector } from '@reduxjs/toolkit';

import { selectProduct } from 'src/redux/product/selectors';
import { getTaxonomyBreadcrumbsLinks } from 'src/utils/getBreadcrumbs';

export interface TaxonomyNode {
  href: string;
  title: string;
}

export const selectBreadcrumbsLinks = createSelector([selectProduct], (product) =>
  getTaxonomyBreadcrumbsLinks(product).map(({ rel, title }) => ({ rel, text: title })),
);

/**
 * The taxonomy node the product sits in, which is the last breadcrumb link.
 * Index 0 is always the homepage, so a single-entry list means the product has
 * no taxonomy attributes and there is no node to link to.
 */
export const selectDeepestTaxonomyNode = createSelector(
  [selectProduct],
  (product): TaxonomyNode | null => {
    const links = getTaxonomyBreadcrumbsLinks(product);

    if (links.length < 2) {
      return null;
    }

    const { href, title } = links[links.length - 1];

    return { href, title };
  },
);
